///<reference path="../event/EventDispatcher.ts"/>

namespace com.enirva.debug
{
	import EventDispatcher = com.enirva.event.EventDispatcher;

	export class Debugger extends EventDispatcher
	{
		private static _instance: Debugger;

		private static initialized:boolean;

		private logText: string;

		private logTag: HTMLElement;

		private fpsTag: HTMLElement;

		private minimizeHideContainer:HTMLElement;
		
		private inputText1:HTMLElement;
		
		private inputText2:HTMLElement;
		
		private inputText3:HTMLElement;
		
		private inputText4:HTMLElement;

		public static isDebug: boolean;

		private static _isMinimize:boolean;

		public static fontSize: string = "0.6em";

		public static fontColor: string = "#fff";


		public static initialize(container: HTMLElement): void
		{
			if (Debugger.initialized)
			{
				return;
			}

			if (Debugger._instance == null)
			{
				Debugger._instance = new Debugger();
				Debugger._instance.logText = "";
			}

			Debugger.isDebug = true;
			
			var tag: HTMLElement = document.createElement("div");
			tag.setAttribute("id", "ENIRVA_Debugger");
			tag.style.position = "fixed";
			tag.style.left = "0";
			tag.style.bottom = "0";
			tag.style.width = "320px";
			tag.style.zIndex = "99999";
			tag.style.margin = "0";
			tag.style.padding = "5px";
			tag.style.background = "rgba(30, 30, 30, 0.75)";
			tag.style.minWidth = "100px";


			var hideContainer:HTMLElement = document.createElement("div");

			var fps: HTMLElement = document.createElement("p");
			fps.style.padding = "5px";
			fps.style.margin = "0";
			fps.style.fontSize = Debugger.fontSize;
			fps.style.color = Debugger.fontColor;
			fps.style.lineHeight = "1.5";
			fps.innerHTML = "fps:0";

			var input: HTMLElement = document.createElement("input");
			input.setAttribute("type", "button");
			input.setAttribute("value", "clear");
			input.onclick = function (): void
			{
				Debugger.clear();
			};
			
			var inputT1: HTMLElement = document.createElement("input");
			inputT1.setAttribute("type", "text");
			
			var inputT2: HTMLElement = document.createElement("input");
			inputT2.setAttribute("type", "text");
			
			var inputT3: HTMLElement = document.createElement("input");
			inputT3.setAttribute("type", "text");
			
			var inputT4: HTMLElement = document.createElement("input");
			inputT4.setAttribute("type", "text");
			
			var w:number = 300;
			inputT1.style.width = w + "px";
			inputT2.style.width = w + "px";
			inputT3.style.width = w + "px";
			
			var div1:HTMLElement = document.createElement("div");
			var div2:HTMLElement = document.createElement("div");
			var div3:HTMLElement = document.createElement("div");
			var div4:HTMLElement = document.createElement("div");

			var log: HTMLElement = document.createElement("p");
			log.style.padding = "5px";
			log.style.margin = "0";
			log.style.fontSize = Debugger.fontSize;
			log.style.color = Debugger.fontColor;
			log.style["pointer-events"] = "none";
			log.style.lineHeight = "1.5";

			tag.appendChild(fps);
			tag.appendChild(hideContainer);
			hideContainer.appendChild(input);
			hideContainer.appendChild(div1);
			hideContainer.appendChild(div2);
			hideContainer.appendChild(div3);
			hideContainer.appendChild(div4);
			div1.appendChild(inputT1);
			div2.appendChild(inputT2);
			div3.appendChild(inputT3);
			//div4.appendChild(inputT4);
			hideContainer.appendChild(log);
			
			Debugger._instance.logTag = log;
			Debugger._instance.fpsTag = fps;
			Debugger._instance.inputText1 = inputT1;
			Debugger._instance.inputText2 = inputT2;
			Debugger._instance.inputText3 = inputT3;
			Debugger._instance.inputText4 = inputT4;
			Debugger._instance.minimizeHideContainer = hideContainer;
			Debugger._instance.recFps();

			container.appendChild(tag);
			
			Debugger.initialized = true;
		}


		public static set isMinimize(value:boolean)
		{
			Debugger._isMinimize = value;

			if (value)
			{
				Debugger._instance.minimizeHideContainer.style.display = "none";
			}
			else
			{
				Debugger._instance.minimizeHideContainer.style.display = "block";
			}
		}


		public static get isMinimize():boolean
		{
			return Debugger._isMinimize;
		}
		
		
		public static text(index:number, str:any):void
		{
			if(!Debugger._instance) return;

			if (Debugger.isMinimize) return;

      if (index == 0)
			{
				$(Debugger._instance.inputText1).val(str);
			}
			else if (index == 1)
			{
				$(Debugger._instance.inputText2).val(str);
			}
			else if (index == 2)
			{
				$(Debugger._instance.inputText3).val(str);
			}
			else if (index == 3)
			{
				$(Debugger._instance.inputText4).val(str);
			}
			else
			{
				console.log(str);
			}
		}


		public static log(msg: any): void
		{
			if (Debugger.isDebug)
			{
				console.log(msg);
				Debugger._instance.logText += msg + "<br>";
				Debugger._instance.update();
			}
		}


		public static clear(): void
		{
			if (Debugger.isDebug)
			{
				console.log("clear ok");
				Debugger._instance.logText = "";
				Debugger._instance.update();
			}
		}


		private update(): void
		{
			var deb: Debugger = Debugger._instance;

			deb.logTag.innerHTML = deb.logText;
		}


		private recFps(): void
		{
			this.useDeltaTime = true;

			var t: number = 0;
			var cc: number = 0;

			var tag: HTMLElement = this.fpsTag;

			this.onEnterFrame = function (deltaTime: number): void
			{
				cc++;

				if ((t += deltaTime) >= 1000)
				{
					tag.innerHTML = "fps:" + cc.toString();
					t = 0;
					cc = 0;
				}
			};
		}
	}
}

